import Portal = require("portal-gis");
import Collection = require("../collections/symbology-collection");

let data = new Collection();
export = data; 